import { useMemo } from 'react'
import { useFiatCurrenciesQuery } from 'hooks/queries/useFiatCurrenciesQuery'
import { useSupportedCurrencies } from 'hooks/useSupportedCurrencies'

export const useCurrenciesOptions = () => {
  const { data: currencyData, isPending: isFiatCurrenciesLoading } = useFiatCurrenciesQuery()
  const { getCurrencyOptions } = useSupportedCurrencies()

  const currencyOptions = useMemo(() => getCurrencyOptions(currencyData), [currencyData])

  return {
    currencyOptions,
    isCurrenciesLoading: isFiatCurrenciesLoading,
  }
}
